import ElectronWebView from './ElectronWebView.jsx'; // eslint-disable-line

export default ElectronWebView;
